/* global abGoogleAnalytics */

const salonId = 'UA-1232497-1';
let isSalon = false;

const GA_SEND = 'SalonTracker.send';

export function loadGoogleAnalyticsSalon(articleUrl) {
    if (typeof abGoogleAnalytics === 'undefined') return;
    isSalon = articleUrl.indexOf('salon.com') !== -1;
    if (!isSalon) return;

    abGoogleAnalytics('create', salonId, 'auto', 'SalonTracker');
    abGoogleAnalytics('SalonTracker.set', 'page', articleUrl);

    const gaEvent = {
        hitType: 'event',
        eventCategory: 'Action Button',
        eventAction: 'Widget Loaded'
    };
    abGoogleAnalytics(GA_SEND, gaEvent);
}

export function onWidgetVisibleSalon() {
    if (typeof abGoogleAnalytics === 'undefined') return;
    if (!isSalon) return;

    const gaEvent = {
        hitType: 'event',
        eventCategory: 'Action Button',
        eventAction: 'Widget Visible'
    };
    abGoogleAnalytics(GA_SEND, gaEvent);
}

let engagmentRecorded = false;
export function onEngagement() {
    if (engagmentRecorded) return;
    if (typeof abGoogleAnalytics === 'undefined') return;
    if (!isSalon) return;

    const gaEvent = {
        hitType: 'event',
        eventCategory: 'Action Button',
        eventAction: 'Widget Clicked'
    };
    abGoogleAnalytics(GA_SEND, gaEvent);
    engagmentRecorded = true;
}



// WEBPACK FOOTER //
// ./src/utils/tracking/salonTracking.js